<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-form/page" class="sidebar__link">
      <AcademicCapIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.new-lead") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-students" class="sidebar__link">
      <UserIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.students-list") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-groups" class="sidebar__link">
      <UsersIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.groups-list") }}</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/admin-space-shop" class="sidebar__link">
      <ShoppingBagIcon class="w-6 h-6" />
      <p>Shop</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/admin-mentors" class="sidebar__link">
      <AcademicCapIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.mentors") }}</p>
    </router-link>
  </div>
  <!-- <div class="sidebar__link-wrapper">
      <router-link to="/admin-coins" class="sidebar__link">
        <CurrencyDollarIcon class="w-6 h-6" />
        <p>Coins</p>
      </router-link>
    </div> -->
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-test" class="sidebar__link">
      <DocumentTextIcon class="w-6 h-6" />
      <p>Test</p>
    </router-link>
  </div>

  <div v-if="!isItSupport" class="flex justify-center sidebar__link-wrapper">
    <button class="flex flex-col justify-center items-center sidebar__link text-primary" @click="isModalOpen = true">
      <ArrowDownTrayIcon class="w-6 h-6" />
      <p class="text-center">{{ $t("Sidebar.monthly-report") }}</p>
    </button>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-sms" class="sidebar__link">
      <EnvelopeIcon class="w-6 h-6" />
      <p>SMS</p>
    </router-link>
  </div>
  <div v-if="isDeveloper || isItSupport" class="sidebar__link-wrapper">
    <router-link to="/it-issues" class="sidebar__link">
      <BugAntIcon class="w-6 h-6" />
      <p>IT Issues</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-referrals" class="sidebar__link">
      <LinkIcon class="w-6 h-6" />
      <p>Referal</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-surveys" class="sidebar__link">
      <ClipboardDocumentListIcon class="w-6 h-6" />
      <p>{{ $t("Surveys.title") }}</p>
    </router-link>
  </div>
  <div v-if="isSuperUser" class="sidebar__link-wrapper">
    <router-link to="/admin-invoices" class="sidebar__link">
      <BanknotesIcon class="w-6 h-6" />
      <p>Invoices</p>
    </router-link>
  </div>
  <div v-if="isSuperUser" class="sidebar__link-wrapper">
    <router-link to="/admin-ai-usage" class="sidebar__link">
      <CpuChipIcon class="w-6 h-6" />
      <p>AI Usage</p>
    </router-link>
  </div>
  <div v-if="hasHeadAccess" class="sidebar__link-wrapper">
    <router-link to="/statistics" class="sidebar__link">
      <ChartBarIcon class="w-6 h-6" />
      <p>Статистика</p>
    </router-link>
  </div>
  <div v-if="hasHeadAccess" class="sidebar__link-wrapper">
    <router-link to="/admin-push" class="sidebar__link">
      <MegaphoneIcon class="w-6 h-6" />
      <p>{{ $t("PushBroadcast.menu") }}</p>
    </router-link>
  </div>
  <div v-if="hasHeadAccess" class="sidebar__link-wrapper">
    <router-link to="/events" class="sidebar__link">
      <CalendarDaysIcon class="w-6 h-6" />
      <p>{{ t("Sidebar.events") }}</p>
    </router-link>
  </div>
  <AdminMonthlyStatsModal v-model:visible="isModalOpen" />
</template>

<script setup>
import { useI18n } from "vue-i18n";
import {
  AcademicCapIcon,
  UserIcon,
  UsersIcon,
  ShoppingBagIcon,
  DocumentTextIcon,
  ArrowDownTrayIcon,
  EnvelopeIcon,
  LinkIcon,
  BanknotesIcon,
  BugAntIcon,
  CpuChipIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  MegaphoneIcon,
  CalendarDaysIcon,
} from "@heroicons/vue/24/outline";
import AdminMonthlyStatsModal from "../AdminMonthlyStatsModal.vue";
import { ref, computed } from "vue";
import { storageGet, STORAGE_KEYS } from "@/services/storage.service";

const { t } = useI18n();
const isModalOpen = ref(false);
const isSuperUser = computed(() => !!storageGet(STORAGE_KEYS.SUPER_USER));
const isItSupport = computed(() => !!storageGet(STORAGE_KEYS.IS_IT_SUPPORT));
const isDeveloper = computed(() => !!storageGet(STORAGE_KEYS.IS_DEVELOPER));
const hasHeadAccess = computed(
  () => !!isSuperUser.value || storageGet(STORAGE_KEYS.HEAD_ACCESS) === "true"
);
</script>
